// Intake is a request, not a governance review. Neutralise legacy draft flags
// without changing any other answers or touching existing initiative reviews.
export function clearIntakeGovernance<T extends object>(draft: T) {
  return {
    ...draft,
    regulatoryApprovalRequired: false,
    materialCapitalCommitment: false,
    contractualExclusivity: false,
    materialEnterpriseRisk: false,
  };
}

export function clearIntakeReviewFields<T extends object>(draft: T) {
  return {
    ...clearIntakeGovernance(draft),
    productOwner: "",
    technicalOwner: "",
  };
}
